import React from 'react';
import './ChecklistChoice.scss';

// Green color scheme — cherry-picked from feature/LT-2951_Nutrition-And-Rehabilitation (GreenChoiceButton)
const greenColorScheme = {
  bgColor: '#F2F7F1',
  labelShadowColor: '#6BC94866',
  labelDropShadowColor: '#6BC94866',
  textColor: '#3C9D47',
  activeGradientStart: '#057036',
  activeGradientEnd: '#51BA62',
  activeBorderGradientStart: '#ABECB0',
  activeBorderGradientEnd: '#16570A',
  activeBoxShadowColor: '#BEDEC3',
  activeLabelInnerBg: '#0BBA55',
};

/**
 * Green choice button for begin challenge checklist.
 * Ported from GreenChoiceButton + ChoiceButton in feature/LT-2951_Nutrition-And-Rehabilitation.
 *
 * @param {boolean}  active       - whether this choice is currently selected
 * @param {string}   choiceLabel  - letter shown in the circle bubble (e.g. "ก", "ข", "ค")
 * @param {string}   choiceText   - answer text displayed next to the bubble
 * @param {string}   width        - optional width override
 * @param {function} onClick      - called when the choice is tapped
 */
const ChecklistChoice = ({
  active = false,
  choiceLabel = 'ก',
  choiceText = '',
  width = undefined,
  onClick = () => {},
}) => {
  const {
    bgColor,
    labelShadowColor,
    labelDropShadowColor,
    textColor,
    activeGradientStart,
    activeGradientEnd,
    activeBorderGradientStart,
    activeBorderGradientEnd,
    activeBoxShadowColor,
    activeLabelInnerBg,
  } = greenColorScheme;

  const cssVars = {
    ...(bgColor && { '--cb-bg-color': bgColor }),
    ...(labelShadowColor && { '--cb-label-shadow-color': labelShadowColor }),
    ...(labelDropShadowColor && { '--cb-label-drop-shadow-color': labelDropShadowColor }),
    ...(textColor && { '--cb-text-color': textColor }),
    ...(activeGradientStart && { '--cb-active-gradient-start': activeGradientStart }),
    ...(activeGradientEnd && { '--cb-active-gradient-end': activeGradientEnd }),
    ...(activeBorderGradientStart && { '--cb-active-border-gradient-start': activeBorderGradientStart }),
    ...(activeBorderGradientEnd && { '--cb-active-border-gradient-end': activeBorderGradientEnd }),
    ...(activeBoxShadowColor && { '--cb-active-box-shadow-color': activeBoxShadowColor }),
    ...(activeLabelInnerBg && { '--cb-active-label-inner-bg': activeLabelInnerBg }),
    ...(width && { width }),
  };

  return (
    <div
      className={`choice-button-container${active ? ' choice-button-active' : ''}`}
      onClick={onClick}
      style={cssVars}
    >
      <div className="choice-button-label">
        <div className="choice-button-label-inner">
          <div className="choice-button-label-text">{choiceLabel}</div>
        </div>
      </div>
      <div className="choice-button-text">{choiceText}</div>
    </div>
  );
};

export default ChecklistChoice;
